import moment from 'moment';
import { map, keys, values, pick, each } from 'lodash';
import { filterByFiltering } from '../selectors/selectors';
const HTTP_REGEX = RegExp('http(s)?://');

/**
 * Downloads a new file from an Array of records.
 * @param {Array} records The records to store in the generated CSV file
 * @param {String} filename The name of the downloaded file (current date will be appended)
 * @param {Object} filtering Filter the records with an specific set of key-values
 * @param {Object} columns An object representing a key-value of columns
 * @param {Array} pickArray The column names
 * @param {Function} onDownloaded a function to call when the CSV is downloaded.
 * @returns {Function} An event handler function to be associated with a click event.
 */
export default function (records, filename, filtering, columns, pickArray, onDownloaded) {

  return e => {
    e.preventDefault();
    const encodedUri =  prepareCSVRecords(records,filtering,columns,pickArray);
    const link = createDownloadLink(encodedUri, filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    onDownloaded && typeof onDownloaded === 'function' && onDownloaded();
  };
}

export function createDownloadLink (encodedUri, filename) {
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${filename}-${moment().format('YYYY-MM')}`);
  return link;
}

export function prepareCSVRecords (records, filtering, columns, pickArray) {
  const pickedRecords =
      pickArray && pickArray.length >= 1
        ? records.map(record => pick(record, pickArray))
        : records;
    const filteredRecords = filtering
      ? filterByFiltering(pickedRecords, filtering)
      : pickedRecords;

    let csv = 'data:text/csv;charset=utf-8,';

    if (columns) {
      csv += `${keys(filteredRecords[0])
        .map(record => columns[record] || record)
        .join(',')} \n`;
    } else {
      csv += `${keys(filteredRecords[0]).join(',')} \n`;
    }

    csv += map(filteredRecords, r => {
      each(Object.keys(r),(key) => {
        if(HTTP_REGEX.test(r[key])){
          r[key] = encodeURIComponent(r[key]);
        }
      });
      return values(r).join(',');
    }).join('\n');

    return encodeURI(csv);
}